import styled from 'styled-components';
import { Form, Input, InputNumber } from 'antd';
import { Text } from '@/components/Typography';

interface CustomTextProps {
	$bold: boolean;
}

export const CustomText = styled(Text)<CustomTextProps>`
	font-size: 1.1rem;
	font-weight: ${({ $bold }) => ($bold ? '600' : '400')};
`;

export const CustomInput = styled(Input)`
	border-radius: 6px;
	border: 1px solid #e9e9e9;
`;

export const CustomTextArea = styled(Input.TextArea)`
	border-radius: 6px;
	border: 1px solid #e9e9e9;
`;

export const CustomInputNumber = styled(InputNumber)`
	border-radius: 6px;
	border: 1px solid #e9e9e9;
`;

export const CustomFormItem = styled(Form.Item)`
	margin: 0;

	.ant-form-item-explain-error {
		margin-top: 5px;
		position: absolute;
		white-space: nowrap;
	}
`;
